import { HomeNotifications } from '@/features/notifications/HomeNotifications';
import { useWidgetBoard } from '../widgetBoardContext';

/**
 * The person's latest notifications, as a widget. Under a widget's heading on
 * a Dashboard, where it stands beside others; with the small heading it has
 * always had on the Overview, which reads top to bottom. Either way its
 * heading carries the control that takes it off the screen.
 */
export function NotificationsWidget() {
  const board = useWidgetBoard();
  return (
    <HomeNotifications
      asWidget={board?.stacked === false}
      onHide={board === null ? undefined : () => board.hide('notifications')}
    />
  );
}
